<div
  class="flex flex-col w-full bg-white
         h-[100dvh] md:h-auto md:max-h-[85vh]
         md:w-[550px] md:min-h-[400px]
         overflow-hidden">

  <!-- Title Dialog -->
  <div class="flex justify-between items-center p-4">
    <span class="text-lg font-bold uppercase">{{"stripe.dialoTitle"|translate}}</span>
    <img src="assets/img/stripe-logo/stripe.png" class="h-12">
  </div>

  <!-- Loading GIF -->
  <div *ngIf="formIsLoading || spinnerPayIsLoading" class="flex flex-col items-center">
    <img src="/assets/img/spinner.gif" class="h-24">
  </div>

  <!-- Stripe Payment Section -->
  <div class="flex-1 overflow-y-auto">
    <!-- Stripe Payment Form -->
    <form id="payment-form" class="p-4">
      <div id="payment-element">
        <!--Stripe.js injects the Payment Element-->
      </div>
      <!-- Display  message -->
      <div id="payment-message" class="hidden"></div>
    </form>
  </div>

  <!-- Submit buttons -->
  <div class="shrink-0 ">
    <div *ngIf="!formIsLoading" class="flex justify-between p-4">

      <!-- Cancel Button -->
      <button (click)="closeDial()"
              [ngClass]="cssService.defaultNegativeDialogButton" class="px-4"
              angulartics2On="click" angularticsAction="cancelPayStripe"
              angularticsCategory="order" [disabled]="spinnerPayIsLoading">
        <span>{{'cancel_button'|translate}}</span>
      </button>

      <!-- Submit Button -->
      <button
        [ngClass]="cssService.defaultActionButton"
        (click)="submitOrder($event)" [disabled]="spinnerPayIsLoading">
            <span>{{"button.pay"|translate}}
              {{amount|priceFilter:
                currency?.symbol:
                currency?.decimal }}</span>
      </button>
    </div>
  </div>
</div>